module.exports = __webpack_public_path__ + "static/media/mifold-scrn.d7569a00.jpg";